// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","content":"App_content__wwONY","welcome":"App_welcome__hujqg","list":"App_list__wZm26"};